(ns app.front.view.workspace.route-subs
  (:require [app.front.form.add :as add-form]
            [app.front.process :as process]
            [app.front.review-v2.subs :as review-subs]
            [app.front.view.application :as application]
            [app.front.view.application.utils :as app-utils]
            [app.front.view.approval.core :as approval-core]
            [app.front.view.case-note.subs :as cn-subs]
            [app.front.view.conditions.list :as conditions-list]
            [app.front.view.fee.events :as fee-events]
            [app.front.view.inspections.add :as inspection-add]
            [app.front.view.inspections.orders-section :as orders-section]
            [app.front.view.letter.section :as letter-section]
            [app.front.view.meeting.meeting-events :as meeting-events]
            [app.front.view.party.party-section-v2 :as party-section-v2]
            [app.front.view.party.subs-req :as party-req-subs]
            [app.front.view.periodic-inspection :as periodic-inspection]
            [app.front.view.pre-consultation.view :as pre-consultation-view]
            [app.front.view.workspace.alerts :as ws-alerts]
            [app.front.view.workspace.primary-actions :as primary-actions]
            [app.front.view.workspace.subs :as ws-subs]
            [app.front.view.workspace.util :as ws-util]
            [app.front.view.workspace.workspace-labels :as workspace-labels]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))


(defn- group-actions [resolved admin]
  (let [buttons     (filter #(= (:ui-type %) :primary) resolved)
        panel-items (remove #(= (:ui-type %) :primary) resolved)
        all         (concat panel-items admin)]
    {:buttons     buttons
     :panel-items (remove nil? all)}))


(defn workspace-back-route [match search-updates?]
  (if (and search-updates? (ws-util/search-origin-query-params match))
    [:view/search nil {:selected-tab "workspace"}]
    [:dashboard]))


(rf/reg-sub ::workspace-back-href
  :<- [:route/match]
  :<- [::ff/enabled? :feature-flag.id/workspace-search-updates]
  (fn [[match search-updates?] _]
    (apply href/href (workspace-back-route match search-updates?))))


(rf/reg-sub ::workspace-back-view-data
  :<- [::workspace-back-href]
  (fn [back-href _]
    {:back-href back-href}))


(rf/reg-sub ::workspace-view-data
  :<- [:route/match]
  :<- [::workspace-back-href]
  :<- [::ws-subs/workspace]
  :<- [:session/admin?]
  :<- [::workspace-options]
  :<- [::ws-alerts/visible-alerts]
  (fn [[match back-href workspace admin? options alerts] _]
    (let [phase              (-> match :data :phase)
          process-sub        (some-> phase process/workspace-process-subs)
          process            (when process-sub (<sub [process-sub]))
          process-target-sub (some-> phase process/workspace-process-target-subs)
          process-target     (when process-target-sub (<sub [process-target-sub]))
          can-write?         (-> workspace :granted-permissions :permission.application/review)
          resolved           (app-utils/resolve-primary-actions process true)
          admin-actions      (primary-actions/admin-special-actions admin? can-write?)
          {:keys [buttons panel-items]}
          (group-actions resolved admin-actions)]
      {:back-href back-href
       :actions   {:process-target process-target
                   :buttons        (vec buttons)
                   :panel-items    (vec panel-items)}
       :options   options
       :alerts    alerts})))


(rf/reg-sub ::workspace-sub-page-view-data
  :<- [:route/match]
  :<- [::ws-subs/href]
  :<- [::ws-subs/workspace]
  :<- [:session/admin?]
  (fn [[match href workspace admin?] _]
    (let [phase                         (-> match :data :phase)
          process-sub                   (some-> phase process/workspace-process-subs)
          process                       (when process-sub (<sub [process-sub]))
          process-target-sub            (some-> phase process/workspace-process-target-subs)
          process-target                (when process-target-sub (<sub [process-target-sub]))
          can-write?                    (-> workspace :granted-permissions :permission.application/review)
          resolved                      (app-utils/resolve-primary-actions process true)
          admin-actions                 (primary-actions/admin-special-actions admin? can-write?)
          {:keys [buttons panel-items]} (group-actions resolved admin-actions)]
      {:back-href (or (<sub [::review-subs/review-back-href]) href)
       :actions   {:process-target process-target
                   :buttons        (vec buttons)
                   :panel-items    (vec panel-items)}
       :options   {:items []}})))


(defn- workspace-extra-actions
  "Build extra actions for workspace options panel."
  [tr process-target phase]
  (let [target-id                  (:db/id process-target)
        permitted?                 #(<sub [::process/signal-permitted? target-id %])
        default-approver-groups    (<sub [::ws-subs/default-approver-groups])
        orders-enabled?            (<sub [::ws-subs/has-feature? :orders-for-inspections-enabled?])
        fees-enabled?              (<sub [::ws-subs/has-feature? :fees-and-payments?])
        scroll-to-attachments      (case phase
                                     :workspace.state/periodic-parent [::periodic-inspection/scroll-to-attachments]
                                     :workspace.state/execution [::application/trigger-scroll-to-execution-attachments]
                                     :workspace.state/application [::application/trigger-scroll-to-application-attachments]
                                     :workspace.state/pre-consultation [::pre-consultation-view/scroll-to-attachments]
                                     nil)
        add-attachment-requirement (case phase
                                     :workspace.state/periodic-parent [::periodic-inspection/trigger-add-attachment-requirement]
                                     :workspace.state/execution [::application/trigger-add-execution-attachment-requirement]
                                     :workspace.state/application [::application/trigger-add-application-attachment-requirement]
                                     :workspace.state/pre-consultation [::pre-consultation-view/trigger-add-attachment-requirement]
                                     nil)
        pre-consultation?          (= phase :workspace.state/pre-consultation)
        periodic-parent?           (= phase :workspace.state/periodic-parent)
        application?               (= phase :workspace.state/application)
        execution?                 (= phase :workspace.state/execution)
        pre-issuance-orders?       (and (or pre-consultation? application?)
                                        (<sub [::ff/enabled? :feature-flag.id/pre-issuance-inspections]))
        execution-forms-visible?   (and execution?
                                        (<sub [::application/case-data-section-visible? process-target]))]
    (cond-> []
      (permitted? [:process.signal/add-party])
      (conj {:id       :add-party
             :label    (tr [:application/invite-button])
             :on-click #(>evt [::party-section-v2/trigger-add-party process-target])})

      (<sub [::party-req-subs/can-add-role-requirement? target-id])
      (conj {:id       :add-required-party-role
             :label    (tr [:party/add-required-role])
             :on-click #(>evt [::party-section-v2/trigger-add-required-party-role process-target])})

      (and (or pre-consultation? periodic-parent? application? execution-forms-visible?)
           (permitted? [:process.signal/add-form]))
      (conj {:id       :add-form
             :label    (tr [:process.signal/add-form])
             :on-click #(>evt [::add-form/trigger-add-form process-target])})

      (and pre-consultation?
           (permitted? [:process.signal/create-application-condition]))
      (conj {:id       :add-condition
             :label    (tr [:condition/add])
             :on-click #(>evt [::conditions-list/trigger-add-condition])})

      (and add-attachment-requirement
           (permitted? [:process.signal/add-attachment-requirement]))
      (conj {:id       :add-attachment-requirement
             :label    (tr [:attachments/add-attachment-type])
             :on-click #(>evt add-attachment-requirement)})

      (and scroll-to-attachments
           (permitted? [:process.signal/attachment-create-with-version]))
      (conj {:id       :upload-attachment
             :label    (tr [:attachments/add-new])
             :on-click #(>evt scroll-to-attachments)})

      (and (or application? execution? pre-consultation?)
           (permitted? [:process.signal/add-inspection]))
      (conj {:id       :add-inspection
             :label    (tr [:inspection/add-new])
             :on-click #(>evt [::inspection-add/trigger-add-inspection
                               (if pre-consultation?
                                 :pre-consultation-inspections
                                 :application-inspections)])})

      (and (or execution? pre-issuance-orders?)
           orders-enabled?
           (permitted? [:process.signal/create-inspection-order]))
      (conj {:id       :add-order
             :label    (tr [:inspection/add-new-order])
             :on-click #(>evt [::orders-section/trigger-add-order])})

      (permitted? [:process.signal/generate-letter])
      (conj {:id       :add-letter
             :label    (tr [:letter/generate])
             :on-click #(>evt [::letter-section/trigger-add-letter])})

      (and (or pre-consultation? application? execution?)
           (permitted? [:process.signal/add-case-note]))
      (conj {:id       :add-case-note
             :label    (tr [:case-note/add])
             :on-click #(>evt [::cn-subs/trigger-add-case-note])})

      (and execution?
           (permitted? [:process.signal/set-partial-occupancy]))
      (conj {:id       :configure-occupancy
             :label    (tr [:occupancy/allow-partial-occupancy])
             :on-click #(>evt [::application/trigger-open-occupancy-section])})

      (and fees-enabled?
           (permitted? [:process.signal/add-bill {:phase :bill.phase/permit}]))
      (conj {:id       :add-permit-bill
             :label    (tr [:fees/add-permit-bill])
             :on-click #(>evt [::fee-events/add-bill-and-scroll process-target [:process.signal/add-bill {:phase :bill.phase/permit}]])})

      (and fees-enabled?
           (permitted? [:process.signal/add-bill {:phase :bill.phase/additional}]))
      (conj {:id       :add-additional-bill
             :label    (tr [:fees/add-additional-bill])
             :on-click #(>evt [::fee-events/add-bill-and-scroll process-target [:process.signal/add-bill {:phase :bill.phase/additional}]])})

      (permitted? [:process.signal/create-approval])
      (conj {:id       :add-circulation-request
             :label    (tr [:approval/add-request])
             :on-click #(>evt [::approval-core/add-request-and-scroll default-approver-groups])})

      (and pre-consultation?
           (permitted? [:process.signal/create-meeting-draft]))
      (conj {:id       :add-meeting
             :label    (tr [:meeting/create])
             :on-click #(>evt [::meeting-events/create-draft target-id])})

      ;; Label management runs on the workspace's state machine, so availability — permissions and
      ;; the states where labels may be edited — comes from the signal itself.
      (permitted? [:process.signal/create-workspace-label-group])
      (conj {:id           :label-management
             :label        (tr [:labels/title])
             :has-submenu? true
             :on-click     #(>evt [::workspace-labels/open-panel target-id])}))))

(rf/reg-sub ::workspace-base-options
  :<- [:route/match]
  :<- [::ws-subs/tr]
  :<- [::ws-subs/workspace]
  :<- [:session/admin?]
  :<- [::ws-subs/backend-system-name]
  :<- [::ws-subs/ecm-system-name]
  :<- [::process/current-processing-signals]
  (fn [[match tr workspace admin? backend-system-name ecm-system-name processing-signals] [_ explicit-phase]]
    (let [phase              (or explicit-phase (-> match :data :phase))
          process-sub        (some-> phase process/workspace-process-subs)
          process            (when process-sub (<sub [process-sub]))
          process-target-sub (some-> phase process/workspace-process-target-subs)
          process-target     (when process-target-sub (<sub [process-target-sub]))
          can-write?         (-> workspace :granted-permissions :permission.application/review)
          action-context     (util/mmap backend-system-name ecm-system-name workspace processing-signals)
          base-items         (->> (concat (primary-actions/secondary-actions (util/mmap tr process process-target))
                                          (primary-actions/admin-special-actions admin? can-write?))
                                  (map #(primary-actions/signal->action tr process-target % action-context)))]
      {:items (vec base-items)})))

(rf/reg-sub ::workspace-options
  :<- [::workspace-base-options]
  :<- [:route/match]
  :<- [::ws-subs/tr]
  (fn [[options match tr] _]
    (let [phase              (-> match :data :phase)
          process-target-sub (some-> phase process/workspace-process-target-subs)
          process-target     (when process-target-sub (<sub [process-target-sub]))
          ui-improvements?   (<sub [::ff/enabled? :feature-flag.id/inspection-ui-improvements])
          extra-items        (when ui-improvements?
                               (workspace-extra-actions tr process-target phase))]
      (update options :items into extra-items))))
